import React, { useCallback, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import SectorAllocationPopUp from './sectorAllocationPopUp';

export default function ApexChart({ sectorAllocationGraph }) {
  // Check if series and labels are valid and log them for debugging

  const series = React.useMemo(() => {
    if (!sectorAllocationGraph?.serise) return [];
    return sectorAllocationGraph.serise.map(value => Number(value) || 0);
  }, [sectorAllocationGraph?.serise]);

  const labels = React.useMemo(() => {
    if (!sectorAllocationGraph?.options) return [];
    return sectorAllocationGraph.options.map(label => String(label || ''));
  }, [sectorAllocationGraph?.options]);

  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const handleClick = useCallback((event, chartContext, config) => {
    const seriesIndex = config.dataPointIndex;
    if (seriesIndex !== -1 && labels[seriesIndex] && series[seriesIndex] !== undefined) {
      setSelectedData({
        label: labels[seriesIndex],
        value: series[seriesIndex]
      });
      setShowPopUp(true);
    }
  }, [labels, series]);

  const handleClose = useCallback(() => {
    setShowPopUp(false);
    setSelectedData(null);
  }, []);


  const options = React.useMemo(() => ({
    chart: {
      type: 'donut',
      events: {
        click: handleClick
      }
    },
    colors: ['#1d3b6f', '#a4906b', '#4a4c55', '#63366e', '#a9333a', '#006b68', '#006394', '#6f7197', '#c3b59b', '#828189', '#bf8486', '#bf8486', '#769a98', '#6d94b5'],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: false,
          }
        }
      }
    },
    labels: labels,
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val.toFixed(2)}%`, // Show percentage inside the chart
    },
    tooltip: {
      tooltip: {
        y: {
          formatter: (val, opts) => {
            if (!opts || !opts.w || !opts.w.globals) return val; // Prevent error

            const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0);
            const percentage = ((val / total) * 100).toFixed(2);
            return `${val} (${percentage}%)`;
          }
        }
      },
      custom: function ({ series, seriesIndex, w }) {
        const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
        const percent = ((series[seriesIndex] / total) * 100).toFixed(2);
        const label = w.globals.labels[seriesIndex];
        const value = series[seriesIndex];
        const color = w.config.colors[seriesIndex]; // Get the color for the slice
        return `
          <div class="tooltip-custom" style="padding: 8px; background: ${color}; color: #fff; border-radius: 4px; font-size: 12px;">
            ${label} : ${value} (${percent}%)
          </div>
        `;
      }
    },
    legend: {
      position: 'right',
      verticalAlign: 'center',
      floating: false,
      fontSize: '12px',
      fontFamily: "Montserrat SemiBold",
      color: "#000",
      onItemHover: {
        highlightDataSeries: false, // Disable hover interaction to prevent error
      },
    },
    responsive: [{
      breakpoint: 1180,
      options: {
        chart: {
          height: "400px"
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'bottom',
          verticalAlign: 'bottom',
          offsetY: 0,
          offsetX: 0,
          floating: false,
        }
      }
    }]
  }), [labels, handleClick]);

  return (
    <div className='mt-3'>
      <div id="chart" className='left-donut-chart'>
        <ReactApexChart options={options} series={series} type="donut" />
      </div>
      {showPopUp && selectedData && (
        <SectorAllocationPopUp
          data={selectedData}
          onClose={handleClose}
        />
      )}
      <div id="html-dist"></div>
    </div>
  );
}
